module.exports = '<svg x="0px" y="0px" viewBox="0 0 16 16" xml:space="preserve" width="16" height="16"><g class="nc-icon-wrapper"><polygon points="6,13.4 4.6,12 8.6,8 4.6,4 6,2.6 11.4,8 "></polygon></g></svg>';
